import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { ErrorToast } from '../../components';
import { getUserRegisterFromLS } from '../../helpers/localstorage-helper';
import { LOGIN } from '../../routes/routes';

interface UpdateProfileDetailsType {
  approvalDate: string | undefined;
  referrerId: number | undefined;
  email: string;
  username: string;
  walletAddress: string | undefined;
  country: string;
  countryCode: string;
}

export const updateProfileDetailsWithWallet = createAsyncThunk(
  'auth/updateProfileDetailsWithWallet',
  async (
    {
      referrerId,
      username,
      approvalDate,
      email,
      country,
      countryCode,
      walletAddress
    }: UpdateProfileDetailsType,
    { rejectWithValue }
  ) => {
    try {
      const { data } = await axios.post(`/flipme-auth/signup`, {
        referrerId,
        username,
        approvalDate,
        email,
        country,
        countryCode,
        walletAddress
      });

      return data?.data?.sessionId;
    } catch (error: any) {
      ErrorToast(error.response.data.error);
      return rejectWithValue(error.response.data.error);
    }
  }
);

export const updateProfileDetailsWithoutWallet = createAsyncThunk(
  'auth/updateProfileDetailsWithoutWallet',
  async (
    {
      referrerId,
      username,
      approvalDate,
      email,
      country,
      countryCode,
      result,
      history
    }: {
      referrerId: number;
      username: string;
      approvalDate: string;
      email: string;
      country: string;
      countryCode: string;
      result: any;
      history: any;
    },
    { rejectWithValue }
  ) => {
    try {
      const {
        lot_number: lotNumber,
        captcha_output: captchaOutput,
        pass_token: passToken,
        gen_time: genTime
      } = result;

      await axios.post(`/authorization/email-otp/signup`, {
        referrerId,
        username,
        approvalDate,
        email,
        country,
        countryCode,
        lotNumber,
        captchaOutput,
        passToken,
        genTime
      });

      history.push(LOGIN);

      getUserRegisterFromLS();
    } catch (error: any) {
      ErrorToast(error.response.data.error);
      return rejectWithValue(error.response.data.error);
    }
  }
);
